import { Link } from 'gatsby';
import React, { useEffect, useRef, useState } from 'react';
import { Dropdown } from 'react-bootstrap';
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import '../assets/scss/headers.scss';
import '../assets/scss/index.scss';
import bugsworkLogo from '../assets/images/bugswork-logo.svg';
import bugsworkLogoScroll from '../assets/images/bugswork-dark.svg';
import kababMenu from '../assets/images/kabab-menu.svg';
import Button from 'react-bootstrap/Button';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import 'react-lazy-load-image-component/src/effects/blur.css';
import '../assets/scss/acnavbar.scss';
import '../assets/scss/_common.scss';
import Cookies from 'universal-cookie';
import nocodewhite from '../assets/images/nocode-whit.svg';
import nocodeBlue from '../assets/images/nocode-blue.svg';
import visualWhite from '../assets/images/visual-white.svg';
import visualBlue from '../assets/images/visual-blue.svg';
import useWindowLocation from '../customhooks/useWindowLocation';

const Acnavbar = ({
  home,
  pathname,
  logo,
  logoLogic,
}: {
  home: boolean;
  pathname: string;
  logo: string;
  logoLogic: boolean;
}) => {
  const [showMenu, setShowMenu] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [activeItem, setActiveItem] = useState('');
  const [isMobile, setIsMobileView] = useState(false);
  const [isPrivacyPolicyPage, setIsPrivacyPolicyPage] = useState(false);
  const [Cookie, setCookie] = useState(null);

  const handleClick = (item: any, event: any) => {
    event.stopPropagation();
    setActiveItem(item);
  };

  useEffect(() => {
    const cookies = new Cookies();
    const myCookie = cookies.get('bugs-work-auth');
    setCookie(myCookie);
  }, []);

  const fullPath = useWindowLocation();

  useEffect(() => {
    document.body.classList.add('home-page');
    typeof window !== 'undefined' &&
      (window.onscroll = () => {
        if (window.scrollY < 60) {
          !!sticky.current && sticky.current.classList.remove('secondary');
          setScrolled(false);
        } else {
          !!sticky.current && sticky.current.classList.add('secondary');
          setScrolled(true);
        }
      });
    setIsPrivacyPolicyPage(
      pathname === '/privacy-policy' || pathname === '/terms-of-use'
    );
  }, []);

  useEffect(() => {
    const checkIfMobileView = () => {
      setIsMobileView(window.innerWidth <= 768);
    };

    checkIfMobileView();

    window.addEventListener('resize', checkIfMobileView);
    return () => {
      window.removeEventListener('resize', checkIfMobileView);
    };
  }, []);

  const toggleMenu = () => {
    setShowMenu((prevState) => !prevState);
  };
  const sticky = useRef();
  return (
    <div className={scrolled ? 'blur-effect' : ''}>
      <Navbar
        className={`py-0 ${isPrivacyPolicyPage ? 'privacy-policy-bg' : ''}`}
        id="navbar-ac"
        collapseOnSelect
        sticky="top"
        expand="lg"
        variant="dark"
        ref={sticky}
      >
        <Container className="header-border p-0 py-1">
          <Navbar.Brand className="w-sidebar ms-md-0 ms-lg-0 d-flex justify-content-between flex-row-reverse cust-tab-width m-3">
            <div className="d-flex flex-row-reverse">
              <Navbar.Toggle
                aria-controls="responsive-navbar-nav"
                className="me-md-3 me-0 p-0  ms-md-0 border-0"
                onClick={toggleMenu}
              >
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M3 18V16H21V18H3ZM3 13V11H21V13H3ZM3 8V6H21V8H3Z"
                    fill={
                      pathname === 'BLOG-PAGE'
                        ? '#131A36'
                        : scrolled
                          ? '#131A36'
                          : 'white'
                    }
                  />
                </svg>
              </Navbar.Toggle>
              <div className="d-flex align-items-center mx-lg-3">
                <Link to="/" className="cust-link-mob-only">
                  <LazyLoadImage
                    effect="blur"
                    className={scrolled ? 'cust-mob-only' : 'cust-mob-only'}
                    height={40}
                    src={
                      pathname === 'BLOG-PAGE'
                        ? bugsworkLogoScroll
                        : scrolled
                          ? bugsworkLogoScroll
                          : bugsworkLogo
                    }
                    alt="Logo"
                  />
                </Link>
              </div>
            </div>
            <Link
              to={`${process.env.GATSBY_APP_URL}/registration/`}
              target="_blank"
            >
              <Button className="border-0 btn-contact-us col-lg  d-lg-none py-2 font-13 fw-400">
                Sign up now
              </Button>
            </Link>
          </Navbar.Brand>
          {isMobile ? (
            <>
              <Navbar.Collapse
                id="responsive-navbar-nav"
                className={`responsive-navbar-nav justify-content-end`}
              >
                <Nav className="main-nav-design">
                  <Dropdown
                    className={`lh-2  ${logoLogic ? (scrolled ? '' : 'nav-link-blue') : scrolled ? 'color-white  d-grid  mx-4 my-4' : 'color-white d-grid mx-4 my-4'}`}
                    show={showMenu}
                    onMouseLeave={() => setShowMenu(false)}
                  >
                    <Navbar.Toggle
                      aria-controls="responsive-navbar-nav"
                      className="me-md-3 p-0  ms-md-0 border-0 bg-dark toggle-btn-sm hunbumger-menu"
                      onClick={toggleMenu}
                    >
                      <span aria-hidden="false">&times;</span>
                    </Navbar.Toggle>
                    <div>
                      <a
                        href={'/'}
                        onClick={toggleMenu}
                        className={`cust-select-color dark-color me-4 fs-4 fw-400`}
                      >
                        <span
                          style={{
                            marginTop: '5px',
                            marginBottom: '10px',
                          }}
                        >
                          About bugs.work
                        </span>
                      </a>
                    </div>
                    <Link
                      to="/resource/articles"
                      className={`cust-select-color dark-color me-4 fs-4 fw-400 mr-2`}
                      onClick={toggleMenu}
                    >
                      <span
                        style={{
                          marginTop: '5px',
                          marginBottom: '10px',
                        }}
                      >
                        Articles
                      </span>
                    </Link>
                    <Link
                      to="/pricing"
                      className={`cust-select-color dark-color me-4 fs-4 fw-400 mr-2`}
                      onClick={toggleMenu}
                    >
                      <span
                        style={{
                          marginTop: '5px',
                          marginBottom: '10px',
                        }}
                      >
                        Pricing
                      </span>
                    </Link>

                    <a
                      href={pathname !== '' ? '/#faqs' : '#faqs'}
                      className={`cust-select-color dark-color me-4 fs-4 fw-400 mr-2`}
                      onClick={toggleMenu}
                    >
                      <span
                        style={{
                          marginTop: '5px',
                          marginBottom: '10px',
                        }}
                      >
                        FAQs
                      </span>
                    </a>
                    <a
                      href={`${process.env.GATSBY_APP_URL}/login`}
                      target="_blank"
                      className={`cust-select-color dark-color me-4 fs-4 fw-400 mr-`}
                    >
                      <span
                        style={{
                          marginTop: '5px',
                          marginBottom: '10px',
                        }}
                      >
                        Login
                      </span>
                    </a>
                  </Dropdown>
                </Nav>
              </Navbar.Collapse>
            </>
          ) : (
            <>
              <Navbar.Collapse
                id="responsive-navbar-nav"
                className="responsive-navbar-nav justify-content-end align-items-center"
              >
                <Nav className={`lh-2 mt-3 d-flex align-items-center`}>
                  <Link
                    to="/visual-feedback"
                    className={`${scrolled ? 'text-dark' : 'text-white'} me-5 dropdown-toggle-hover`}
                  >
                    <span
                      className={`me-2 mt-1 font-16 fw-500 cursor-pointer ${pathname === 'BLOG-PAGE' ? 'text-dark' : ''}`}
                    >
                      Features
                    </span>
                  </Link>

                  <Link
                    to="/resource/articles"
                    className={`me-5 fw-500 mr-2 font-16 ${scrolled ? 'text-dark' : 'text-white'}`}
                  >
                    <span
                      className={`me-3 ${pathname === 'BLOG-PAGE' ? 'text-dark' : ''}`}
                    >
                      Articles
                    </span>
                  </Link>
                  <Link
                    to="/pricing"
                    className={`me-5 fw-400 mr-2 font-16 ${scrolled ? 'text-dark' : 'text-white'}`}
                  >
                    <span
                      className={`me-3 ${pathname === 'BLOG-PAGE' ? 'text-dark' : ''}`}
                    >
                      Pricing
                    </span>
                  </Link>

                  <a
                    href={pathname !== '' ? '/#faqs' : '#faqs'}
                    className={`me-5 fw-500 mr-2 font-16 ${scrolled ? 'text-dark' : 'text-white'}`}
                  >
                    <span
                      className={`me-3  ${pathname === 'BLOG-PAGE' ? 'text-dark' : ''} `}
                    >
                      FAQs
                    </span>
                  </a>

                  {!Cookie && (
                    <a
                      href={`${process.env.GATSBY_APP_URL}/login`}
                      target="_blank"
                      className={`f-500 font-16 ${scrolled ? 'text-dark' : 'text-white'}`}
                    >
                      <span
                        className={`me-3 ${pathname === 'BLOG-PAGE' ? 'text-dark' : ''}`}
                      >
                        Login
                      </span>
                    </a>
                  )}

                  <Link
                    className="ms-lg-5"
                    to={`${process.env.GATSBY_APP_URL}/registration/`}
                    target="_blank"
                  >
                    <Button className="border-0 btn-contact-us col-lg  d-lg-block d-none py-2 font-14 fw-500">
                      {Cookie ? 'Go to dashboard' : 'Sign up now'}
                    </Button>
                  </Link>
                </Nav>
              </Navbar.Collapse>
            </>
          )}
        </Container>
      </Navbar>
    </div>
  );
};

export default Acnavbar;
